import { useEffect, useState } from "react"
import checkBox from "../../icons/circular-checkbox.svg"
import checkBoxChecked from "../../icons/circular-checkbox-checked.svg"
import ManualConfig from "./ManualConfig"
import AiConfig from "./AiConfig"
import { CircularProgress, Dialog } from "@mui/material"
import ReviewEdit from "../../icons/revie_edit.svg"
import CloudUp from "../../icons/cloud_up.svg"
import {
  // addNavigationPath,
  setDataQualityConfigModal,
  setBusinessQualityConfigModal,
  setAiRulesModalData,
  getDataQualityGenAiRulesAsync,
  getDataQualityImplementedRulesAsync,
  selectGenAiRules,
  removeGenAiRule,
  // postDataQualityRulesAsync,
  // resetSelectedGenAiRules,
  // resetRulePipelineStatus,
  selectExisitingRules,
  removeExistingRules,
} from "./DataQualitySlice"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import { API_STATUS } from "../../util/StaticData"
import { IExistingRules } from "../../util/interface"

const sampleBusinessQualityManualRules = [
  {
    ruleNo: 1,
    description: "Ensure overall sales value meets 90% historical conformity",
  },
  {
    ruleNo: 2,
    description: "Ensure missing values are filled with nearest certainty",
  },
  {
    ruleNo: 3,
    description: "Ensure recurring values are minimized",
  },
]

const sampleBusinessQualityAiRules = [
  {
    "Rule Title": "Product hierarchy maintained across database",
    Description: "Product hierarchy maintained across database",
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title": `New launch in "Sparkling" category post Jun 2024 and not before that`,
    Description: `New launch in "Sparkling" category post Jun 2024 and not before that`,
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title": `Distributor sales conformity of 84% compared to Retailer sales`,
    Description: `Distributor sales conformity of 84% compared to Retailer sales`,
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title":
      "Volume in Cases is Transactions multiplied with Case lot size",
    Description:
      "Volume in Cases is Transactions multiplied with Case lot size",
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title": "Net Revenue is lower than Gross Revenue",
    Description: "Net Revenue is lower than Gross Revenue",
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title":
      "Outlets are distinctively present within a region. There is no repetition",
    Description: `Outlets are distinctively present within a region. There is no repetition`,
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
]

interface RuleProps {
  ruleNo: string | number
  description: string
  theme?: string
  selected?: (isChecked: boolean) => void
  onEditClick: () => void // Add onEditClick prop
  type: string
}

interface DataQualityGenAiRuleProps {
  "Rule Title": string
  Description: string
  Implementation: string
  Columns_to_apply: string
  Conditions: string
  selected?: (isChecked: boolean) => void
  onEditClick: () => void
  index: number
}

interface DataQualityManualRuleProps {
  index: number | string
  rule: IExistingRules
  theme?: string
  selected?: (isChecked: boolean) => void
  onEditClick: () => void
  type: string
}

const DataQualityManualRuleComp = ({
  index,
  rule,
  theme,
  onEditClick,
  type,
}: DataQualityManualRuleProps) => {
  const dispatch = useAppDispatch()

  const selectRule = () => {
    dispatch(selectExisitingRules({ rule: rule, qualityType: "data-quality" }))
  }

  const disSelectRule = () => {
    dispatch(
      removeExistingRules({
        ruleTitle: rule.existing_rules,
        qualityType: "data-quality",
      }),
    )
  }

  const selectedExistingRules = useAppSelector(
    (state) => state.dataQuality.dataQualityRules.selectedExistingRules,
  )

  const isSelected = selectedExistingRules.includes(rule)

  const handleCheckBox = () => {
    isSelected ? disSelectRule() : selectRule()
    console.log(selectedExistingRules)
  }

  return (
    <div className="flex items-center gap-3 h-11">
      {/* Checkbox and rule content */}
      <div
        className={`h-full border-2 rounded-full ${
          type === "ai" ? "border-primaryBlue" : "border-primaryRed"
        }`}
      />
      <div
        onClick={handleCheckBox}
        className="w-6 h-6 flex-shrink-0 rounded-full cursor-pointer"
      >
        <img
          className="h-full w-full"
          src={isSelected ? checkBoxChecked : checkBox}
          alt="Check Box"
        />
      </div>

      <div className="flex gap-4 h-full items-center grow">
        <div className="flex flex-shrink-0">
          <p
            className={`text-[14px] font-bold flex-shrink-0 ${
              theme === "primaryRed"
                ? "text-primaryRed"
                : theme === "primaryBlue"
                ? "text-primaryBlue"
                : ""
            }`}
          >
            Rule {index}:
          </p>
        </div>

        <div
          className={`flex h-full gap-4 justify-between items-center px-4 py-2 bg-bgGrey-100 grow rounded border ${
            isSelected ? "border-bgGreen-100" : "border-bgGrey-100"
          }`}
        >
          <p className="text-xs">{rule.existing_rules}</p>
          <div
            className="w-6 h-6 flex flex-shrink-0 justify-center items-center cursor-pointer relative group"
            onClick={onEditClick}
          >
            <img className="h-3/4" src={type === "ai" ? CloudUp : ReviewEdit} />

            <div
              style={{ top: `calc(100% + 4px)` }}
              className="hidden group-hover:flex absolute flex items-center justify-center bg-customGrey-500 w-[120px] h-8 rounded z-10"
            >
              <p className="text-xs font-semi-bold whitespace-nowrap text-white">
                {type === "ai" ? "Review & Add" : "Review & Update"}
              </p>
              <div className="absolute top-[-4px] left-1/2 transform -translate-x-1/2">
                <div className="w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-b-4 border-b-customGrey-500"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const DataQualityGenAiRuleComp = ({
  "Rule Title": ruleTitle,
  Description: description,
  Implementation: implementation,
  Columns_to_apply: columnsToApply,
  Conditions: conditions,
  onEditClick,
  index,
}: DataQualityGenAiRuleProps) => {
  const dispatch = useAppDispatch()

  const selectRule = () => {
    dispatch(
      selectGenAiRules({
        rule: {
          "Rule Title": ruleTitle,
          Description: description,
          Implementation: implementation,
          Columns_to_apply: columnsToApply,
          Conditions: conditions,
        },
        qualityType: "data-quality",
      }),
    )
  }

  const disSelectRule = () => {
    dispatch(removeGenAiRule({ ruleTitle, qualityType: "data-quality" }))
  }

  const selectedGenAiRules = useAppSelector(
    (state) => state.dataQuality.dataQualityRules.selectedAiGeneratedRules,
  )

  const isSelected = selectedGenAiRules.some(
    (rule) => rule["Rule Title"] === ruleTitle,
  )

  const handleCheckBox = () => {
    isSelected ? disSelectRule() : selectRule()
  }

  const handleReviewClick = (data: {
    description: string
    implementation: string
    columnsToApply: string
    conditions: string
  }) => {
    dispatch(setAiRulesModalData(data))
    onEditClick()
  }

  return (
    <div className="flex items-center gap-3 h-11">
      <div className="h-full border-2 border-primaryBlue rounded-full" />
      <div
        onClick={handleCheckBox}
        className="w-6 h-6 flex-shrink-0 rounded-full cursor-pointer"
      >
        <img
          className="h-full w-full"
          src={isSelected ? checkBoxChecked : checkBox}
          alt="Check Box"
        />
      </div>

      <div className="flex gap-4 h-full items-center grow">
        <div className="flex flex-shrink-0">
          <p className={`text-[14px] font-bold flex-shrink-0 text-primaryBlue`}>
            Rule {index}:
          </p>
        </div>

        <div
          className={`flex h-full gap-4 justify-between items-center px-4 py-2 bg-bgGrey-100 grow rounded border ${
            isSelected ? "border-bgGreen-100" : "border-bgGrey-100"
          }`}
        >
          <p className="text-xs">{ruleTitle}</p>
          <div
            className="w-6 h-6 flex flex-shrink-0 justify-center items-center cursor-pointer relative group"
            onClick={() =>
              handleReviewClick({
                description,
                columnsToApply,
                conditions,
                implementation,
              })
            }
          >
            <img className="h-3/4" src={CloudUp} />

            <div
              style={{ top: `calc(100% + 4px)` }}
              className="hidden group-hover:flex absolute flex items-center justify-center bg-customGrey-500 w-[120px] h-8 rounded z-10"
            >
              <p className="text-xs font-semi-bold whitespace-nowrap text-white">
                {"Review & Add"}
              </p>
              <div className="absolute top-[-4px] left-1/2 transform -translate-x-1/2">
                <div className="w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-b-4 border-b-customGrey-500"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function DataQualityRules() {
  const openDialog = useAppSelector(
    (state) => state.dataQuality.dataQualityConfigModal,
  )
  const {
    genAiRules,
    existingRules,
    GenAiRulesStatus,
    ImplementedRulesStatus,
    // selectedAiGeneratedRules,
  } = useAppSelector((state) => state.dataQuality.dataQualityRules)
  const [dialogType, setDialogType] = useState("manual")
  const dispatch = useAppDispatch()
  const refresh = useAppSelector((state) => state.dataQuality.refreshHit)

  const selectedDataSet = useAppSelector(
    (state) => state.dataQuality.aiRulesModalData.configuration.dataset,
  ).toLocaleLowerCase()

  useEffect(() => {
    dispatch(getDataQualityGenAiRulesAsync({ raw_data_name: selectedDataSet }))
    dispatch(
      getDataQualityImplementedRulesAsync({ raw_data_name: selectedDataSet }),
    )
  }, [dispatch, refresh])

  const handleOpenDialog = (ruleType: string) => {
    ruleType === "ai" ? setDialogType("ai") : setDialogType("manual")
    dispatch(setDataQualityConfigModal(true))
  }

  const handleCloseDialog = () => {
    dispatch(setDataQualityConfigModal(false))
  }

  return (
    <div className="flex flex-col" style={{ minWidth: "1000px" }}>
      <div className="px-9 py-6 flex bg-white gap-8 my-4 rounded-md min-h-[460px]">
        {/* Manual Rules */}
        <div className="flex flex-col w-1/2 gap-7">
          <div className="rounded flex items-center font-extrabold text-base">
            <p>Implemented Rules</p>
          </div>

          {ImplementedRulesStatus === "idle" && (
            <div className="flex flex-col gap-2 h-full">
              {existingRules.length > 0 ? (
                existingRules.map((rule, index) => (
                  <DataQualityManualRuleComp
                    key={index}
                    index={index + 1}
                    rule={rule}
                    theme={"primaryRed"}
                    onEditClick={() => handleOpenDialog("manual")}
                    type="manual"
                  />
                ))
              ) : (
                <div className="flex items-center justify-center h-full text-xs">
                  <p>No Implemented Rules found</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Divider */}
        <div className="border-l border-customGrey-400" />

        {/* AI Generated Rules */}
        <div className="flex flex-col w-1/2 gap-7">
          <div
            className="w-fit px-3 h-[25px] rounded flex items-center justify-center font-extrabold text-base"
            style={{
              background:
                "linear-gradient(90deg, #67F0FF 0%, #CCC0DD 50%, #FFA0BB 100%)",
            }}
          >
            <p>GenAi Suggested Rules</p>
          </div>

          {GenAiRulesStatus === API_STATUS.IDLE ? (
            <div className="flex flex-col gap-2 h-full">
              {genAiRules.length > 0 ? (
                genAiRules.map((rule, index) => (
                  <DataQualityGenAiRuleComp
                    key={index}
                    index={index + 1}
                    {...rule}
                    selected={(isChecked: boolean) => console.log(isChecked)}
                    onEditClick={() => handleOpenDialog("ai")} // Pass the handler to the component
                  />
                ))
              ) : (
                <div className="flex items-center justify-center h-full text-xs">
                  <p>No GenAi Suggestions found</p>
                </div>
              )}
            </div>
          ) : (
            <div className="flex flex-col gap-1 h-3/4 w-full items-center justify-center">
              <CircularProgress size="35px" />
              <div className="flex flex-col items-center">
                <p className="text-xs">Please wait...</p>
                <p className="text-[10px]">
                  This usually takes 1.5 - 2 minutes to generate
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        {dialogType === "manual" ? <ManualConfig /> : <AiConfig />}
      </Dialog>
    </div>
  )
}

const Rule = ({ ruleNo, description, theme, onEditClick, type }: RuleProps) => {
  const [isChecked, setIsChecked] = useState(false)

  const handleCheckBox = () => {
    setIsChecked(!isChecked)
  }

  return (
    <div className="flex items-center gap-3 h-11">
      {/* Checkbox and rule content */}
      <div
        className={`h-full border-2 rounded-full ${
          type === "ai" ? "border-primaryBlue" : "border-primaryRed"
        }`}
      />
      <div
        onClick={handleCheckBox}
        className="w-6 h-6 flex-shrink-0 rounded-full cursor-pointer"
      >
        <img
          className="h-full w-full"
          src={isChecked ? checkBoxChecked : checkBox}
          alt="Check Box"
        />
      </div>

      <div className="flex gap-4 h-full items-center grow">
        <div className="flex flex-shrink-0">
          <p
            className={`text-[14px] font-bold flex-shrink-0 ${
              theme === "primaryRed"
                ? "text-primaryRed"
                : theme === "primaryBlue"
                ? "text-primaryBlue"
                : ""
            }`}
          >
            Rule {ruleNo}:
          </p>
        </div>

        <div
          className={`flex h-full gap-4 justify-between items-center px-4 py-2 bg-bgGrey-100 grow rounded border ${
            isChecked ? "border-bgGreen-100" : "border-bgGrey-100"
          }`}
        >
          <p className="text-xs">{description}</p>
          <div
            className="w-6 h-6 flex flex-shrink-0 justify-center items-center cursor-pointer relative group"
            onClick={onEditClick}
          >
            <img className="h-3/4" src={type === "ai" ? CloudUp : ReviewEdit} />

            <div
              style={{ top: `calc(100% + 4px)` }}
              className="hidden group-hover:flex absolute flex items-center justify-center bg-customGrey-500 w-[120px] h-8 rounded z-10"
            >
              <p className="text-xs font-semi-bold whitespace-nowrap text-white">
                {type === "ai" ? "Review & Add" : "Review & Update"}
              </p>
              <div className="absolute top-[-4px] left-1/2 transform -translate-x-1/2">
                <div className="w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-b-4 border-b-customGrey-500"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function BusinessQualityRules() {
  // const [openDialog, setOpenDialog] = useState(false)
  const openDialog = useAppSelector(
    (state) => state.dataQuality.businessQualityConfigModal,
  )
  const [dialogType, setDialogType] = useState("manual")
  const dispatch = useAppDispatch()

  const handleOpenDialog = (ruleType: string) => {
    ruleType === "ai" ? setDialogType("ai") : setDialogType("manual")
    dispatch(setBusinessQualityConfigModal(true))
  }

  const handleCloseDialog = () => {
    dispatch(setBusinessQualityConfigModal(false))
  }

  // const handleRunClick = () => {
  //   dispatch(addNavigationPath("Quality Rules Overview"))
  // }

  return (
    <div className="flex flex-col" style={{ minWidth: "1000px" }}>
      <div className="px-9 py-6 min-h-[460px] flex bg-white gap-8 my-4 rounded-md">
        {/* Manual Rules */}
        <div className="flex flex-col w-1/2 gap-7">
          <div className="rounded flex items-center font-extrabold text-base">
            <p>Implemented Rules</p>
          </div>

          <div className="flex flex-col gap-2">
            {sampleBusinessQualityManualRules.map((rule, index) => (
              <Rule
                key={index}
                {...rule}
                theme={"primaryRed"}
                onEditClick={() => handleOpenDialog("manual")}
                type="manual"
              />
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-l border-customGrey-400" />

        {/* AI Generated Rules */}
        <div className="flex flex-col w-1/2 gap-7">
          <div
            className="w-fit px-3 h-[25px] rounded flex items-center justify-center font-extrabold text-base"
            style={{
              background:
                "linear-gradient(90deg, #67F0FF 0%, #CCC0DD 50%, #FFA0BB 100%)",
            }}
          >
            <p>GenAi Suggested Rules</p>
          </div>

          <div className="flex flex-col gap-2">
            {sampleBusinessQualityAiRules.map((rule, index) => (
              <DataQualityGenAiRuleComp
                key={index}
                index={index + 1}
                {...rule}
                selected={(isChecked: boolean) => console.log(isChecked)}
                onEditClick={() => handleOpenDialog("ai")} // Pass the handler to the component
              />
            ))}
          </div>
        </div>
      </div>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        {dialogType === "manual" ? <ManualConfig /> : <AiConfig />}
      </Dialog>
    </div>
  )
}
